import React from "react";
import "./About.css";
import cut from "../../assets/cut-text_09678c85.svg";
import box from '../../assets/box-cut.svg';
import flag from "../../assets/flag.svg";
import skull from "../../assets/skull.svg";
import ag from "../../assets/ag.svg";


const About = () => {
    return (
        <div id="skills" className="section-skills">
            <div className="skills">
                <a href="#pursuits" className="r90 left hide-el bl has-rotate hide-m" data-cursor="false" data-cursor-type="link">
                    <span className="text"> Pursuits&nbsp;</span>
                    <span className="left"> &rarr;</span>
                </a>
                <img decoding="async" src={ag} alt="Awesome guys bubble" className="tiny" data-rellax-speed="1" />
                <img decoding="async" src={skull} alt="Skull Icon" className="skull" data-rellax-speed="1"></img>
                <div id="skills-container" className="skills-container">
                    <div id="skills-left" className="skills-left">
                        <h5 id="about-me" className="h5">About Me</h5>
                        <h2 className="lh2"><strong>Transforming <span className="span-parent">ideas<img className="cut" alt="cut" src={cut} /><span className="span-child">Inspirations</span></span> into Cutting-Edge Solutions with</strong> Passion<strong> and </strong>Precision<strong>.</strong>
                        </h2>
                    </div>
                    <div className="skills-right">
                        <img className="jj" decoding="async" data-aos="fade-up" data-aos-offset="50" src={box} alt="Crossed out box illustration" data-rellax-speed="-1" ></img>
                        <p className="lp">
                            I'm Pravin Kanth, an SDE at HPE Aruba Networking, working on full-stack systems and exploring applied AI in real products.

I enjoy building things end-to-end from architecture decisions to clean interfaces and I'm particularly interested in RAG-based AI systems, cloud platforms and scalable backend design.

Beyond engineering, I actively study economics and financial markets, approaching them the same way I approach software: as complex systems governed by incentives and trade-offs.
                        </p></div>
                </div>
                <img decoding="async" data-aos="fade-up" data-aos-offset="50" src={flag} alt="Hreat flagpole illustration" className="flag-icon" data-rellax-speed="1" ></img>
                <div className="change"></div>
            </div>
        </div>
    );
};

export default About;